import { Layout, Menu } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import {
  NotificationOutlined,
  QrcodeOutlined,
  UserOutlined,
  TrophyOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import logo from "assets/images/logo.png";

const cx = classNames.bind(style);

const { Sider } = Layout
export default function SideBar({ collapsed, setCollapsed }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const { t } = useTranslation()

  const getItem = (label, key, icon, children, type, isShow = true) => {
    return {
      key,
      icon,
      children,
      label,
      type,
      isShow
    };
  };

  const items = useMemo(() => {
    return [
      getItem(
        <div
        >
          {t('listEmployee')}
        </div>,
        "/manager",
        <UserOutlined />,
        null,
        null,
      ),
      getItem(
        <div
        >
          {t('listConfirmQr')}
        </div>,
        "/manager/confirm-qr",
        <QrcodeOutlined />,
        null,
        null,
      ),
      getItem(
        <div
        >
          {t('prizeManagement')}
        </div>,
        "/manager/prize",
        <TrophyOutlined />,
        null,
        null,
      ),
      getItem(
        <div
        >
          {t('condition')}
        </div>,
        "/manager/setting-condition",
        <NotificationOutlined />,
        null,
        null,
      ),
    ];
  }, [t]);

  const onChangeMenu = (val) => {
    navigate(val.key)
  }

  return (
    <Sider onCollapse={(val) => setCollapsed(val)} collapsible collapsed={collapsed} className={cx('sider')}>
      <div className={cx("logo")}>
        <img src={logo} alt="Logo" className={cx("logo-img")} />
      </div>
      <Menu
        mode="inline"
        selectedKeys={[pathname]}
        onClick={onChangeMenu}
        style={{ width: "100%" }}
        items={items.filter(item => item.isShow)}
      />
    </Sider>
  );
}
